import React from 'react';

export function NotFound() {
    return (
        <div className="container">
            <div className="jumbotron">
                <div className="row">
                    <div className="col-sm-1">
                        <i class="fa fa-ban fa-5x" aria-hidden="true" style={{ color: '#a94442' }} />
                    </div>
                    <div className="col-sm-11">
                        <dl className="dl-horizontal">
                            <dt className="text-uppercase">Error Code</dt>
                            <dd>HTTP 404 Not Found</dd>

                            <dt className="text-uppercase">Error Description</dt>
                            <dd>The page you are trying to visit could not be found on the server</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    )
}